import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import Logo from '../ui/Logo';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { loginSlidesAR, loginSlidesEN } from '../../constants/data';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-cube';
import 'swiper/css/pagination';
import { Outlet, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../store';
import { fetchSetting } from '../../features/admin/settingSlice';

const Auth = () => {
    const location = useLocation();
    const { i18n } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    useEffect(() => {
        dispatch(fetchSetting());
    }, [dispatch]);
    const loginText = i18n.language === "ar" ? loginSlidesAR : loginSlidesEN;
    const bgClass = location.pathname === "/auth/login" ? "login-bg" : "register-bg ";
    return (
        <div dir={i18n.language === "ar" ? "rtl" : "ltr"} className='  w-full min-h-screen'>

            <div className='  min-h-screen text-black  ' >
                <div className='  bg-white overflow-hidden   '>
                    <div className='grid grid-cols-2 min-h-screen'>
                        <div className={`col-span-1 ${bgClass}  relative md:block  xs:hidden bg-cover bg-center bg-no-repeat `}>
                            <div className=' login-overlay'></div>
                            <div className='relative z-20  main-prop text-white  '>
                                <div className='text-center w-full flex-center'>
                                    <div className='p-3 w-56 '>
                                        <Logo color='white' />
                                    </div>

                                </div>
                                <div className=' py-5 relative flex flex-col justify-between sm:px-10 lg:px-16  mt-10'>
                                    <div className=' absolute  -top-5 left-10'>
                                        <div className='w-5'>
                                            <img className='w-full' src="/asset/qution.png" alt="" />
                                        </div>

                                    </div>
                                    <div className=''>
                                        <Swiper slidesPerView={1} pagination={true}
                                            autoplay={{
                                                delay: 3000,
                                                disableOnInteraction: false,
                                            }}
                                            modules={[Pagination, Autoplay]}
                                            className=' py-5 relative min-h-96'>
                                            {loginText?.map((item: string, index: number) => (
                                                <SwiperSlide key={index}>
                                                    <div className=''>
                                                        <p className=' text-2xl'>{item}</p>
                                                    </div>
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    </div>

                                </div>
                            </div>

                        </div>
                        <div className=' md:col-span-1 xs:col-span-3 py-5 padding-container    '>
                            <div className='flex-center '>
                                <div className=' w-60 mb-5'>
                                    <Logo color='green' />
                                </div>
                            </div>
                            <Outlet />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Auth
